import { BlogPost } from "~/modules/blog/api/sanity";
import { BlogListItem } from "./BlogListItem";
import { FeaturedPost } from "./FeaturedPost";
import { PageHeader } from "~/components/PageHeader";

// // // //

export function BlogListPage(props: { posts: BlogPost[] }) {
    const { posts } = props;
    const featuredPost = posts.find((p) => p.featured) || posts[0];
    const remainingPosts = posts.filter((p) => p._id !== featuredPost?._id);

    return (
        <div className="max-w-7xl mx-auto">
            <PageHeader
                title="Blog"
                subtitle={
                    "Keep up with the latest news, market trends, and developments in real-world asset tokenization"
                }
            />
            <div className="mt-4 flex flex-col gap-12 pb-16">
                {/* Featured post + sidebar */}
                <div className="grid grid-cols-1 gap-8 lg:grid-cols-1 max-w-4xl">
                    {featuredPost && (
                        <div className="lg:col-span-2">
                            <FeaturedPost post={featuredPost} />
                        </div>
                    )}
                    {/* <BlogSidebar /> */}
                </div>

                {/* Post grid */}
                {remainingPosts.length > 0 && (
                    <div className="grid grid-cols-1 gap-x-6 gap-y-10 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3">
                        {remainingPosts.map((post) => (
                            <BlogListItem key={post._id} post={post} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
